module.exports = __webpack_public_path__ + "img/alipay.358ebe0f.png";